module.exports = __webpack_public_path__ + "static/media/england-queen-logo.77505a53.png";